import { render, staticRenderFns } from "./ent-tag-produce-modal.vue?vue&type=template&id=87538e5e&"
import script from "./ent-tag-produce-modal.vue?vue&type=script&lang=js&"
export * from "./ent-tag-produce-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ent-tag-produce-modal.vue"
export default component.exports